import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchProfileSicknessPageData = createAsyncThunk(
  'profileSickness/fetchPageData',
  async ({ userEmail }, { signal, rejectWithValue }) => {
    try {
      const res = await axios.get(`${API_URL}/api/Profile/Sickness/PageData`, {
        signal,
        headers: { 'Content-Type': 'application/json' },
        params: { userEmail },
      });
      return res.data;
    } catch (e) {
      if (e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError') throw e;
      console.error('profileSickness/fetchPageData failed', e);
      return rejectWithValue(e?.message || 'Failed to fetch sickness page data');
    }
  }
);

export const fetchProfileSicknessFormData = createAsyncThunk(
  'profileSickness/fetchFormData',
  async ({ userEmail, leaveId }, { signal, rejectWithValue }) => {
    try {
      const res = await axios.get(`${API_URL}/api/Profile/Sickness/FormData`, {
        signal,
        headers: { 'Content-Type': 'application/json' },
        params: { userEmail, LeaveID: leaveId },
      });
      return res.data;
    } catch (e) {
      if (e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError') throw e;
      console.error('profileSickness/fetchFormData failed', e);
      return rejectWithValue(e?.message || 'Failed to fetch sickness form');
    }
  }
);

export const updateProfileSicknessForm = createAsyncThunk(
  'profileSickness/updateForm',
  async ({ leaveId, userEmail, action, data }, { signal, rejectWithValue }) => {
    try {
      const res = await axios.post(
        `${API_URL}/api/Profile/Sickness/FormUpdate`,
        { UserEmail: userEmail, Action: action, Data: data },
        {
          signal,
          headers: { 'Content-Type': 'application/json' },
          params: { LeaveID: leaveId },
        }
      );
      return res.data;
    } catch (e) {
      if (e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError') throw e;
      console.error('profileSickness/updateForm failed', e);
      return rejectWithValue(e?.response?.data?.message || e?.message || 'Failed to update sickness form');
    }
  }
);

export const uploadProfileSicknessDocument = createAsyncThunk(
  'profileSickness/uploadDocument',
  async ({ leaveId, docInfo }, { signal, rejectWithValue }) => {
    try {
      const res = await axios.post(
        `${API_URL}/api/Profile/Sickness/DocUpload`,
        docInfo,
        {
          signal,
          params: { LeaveID: leaveId },
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      );
      return res.data;
    } catch (e) {
      if (e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError') throw e;
      console.error('profileSickness/uploadDocument failed', e);
      return rejectWithValue(e?.response?.data?.message || e?.message || 'Failed to upload document');
    }
  }
);

const slice = createSlice({
  name: 'profileSickness',
  initialState: { error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      (action) => action.type.startsWith('profileSickness/') && action.type.endsWith('/rejected'),
      (state, action) => {
        if (action?.meta?.aborted) return;
        state.error = action.payload || action.error?.message || null;
      }
    );
  },
});

export default slice.reducer;


